import { makeGetRequest } from 'owa-ows-gateway';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getGuid } from 'owa-guid';
import { convertEwsIdToRestId } from 'owa-identifiers';
import ItemId from 'owa-service/lib/contract/ItemId';
import GetAutoLabelResponse from '../../store/schema/clp/GetAutoLabelResponse';
import { isSuccessStatusCode } from 'owa-http-status-codes';

const CLP_AUTO_LABELING_ENDPOINT_URI = '/ows/beta/CLPAutoLabeling';

export default async function getCLPAutoLabel(itemId: ItemId): Promise<GetAutoLabelResponse> {
    let restItemId = convertEwsIdToRestId(itemId.Id);
    const userSettings = getUserConfiguration().SessionSettings;
    const userGuid = userSettings ? userSettings.ExternalDirectoryUserGuid : null;

    if (userGuid && restItemId) {
        const correlationId = getGuid();
        let resp = await makeGetRequest(
            `${CLP_AUTO_LABELING_ENDPOINT_URI}/${userGuid}/${restItemId}`,
            correlationId,
            true /*returnFullResponse*/,
            null /*customHeaders*/,
            false /*throwServiceError*/,
            // This flag is to by pass a framework flight that drops all cookies.
            // Dropping cookies will result the auto label server side not able to
            // get all the cookies and return a 401.
            true /*includeCredentials*/
        );
        let getAutoLabelResponse: GetAutoLabelResponse = {
            status: resp.status,
        };

        if (isSuccessStatusCode(resp.status)) {
            let json = await resp.json();
            let autoLabelResult = json.result;
            if (autoLabelResult) {
                getAutoLabelResponse.automatic = autoLabelResult.automatic;
                getAutoLabelResponse.recommended = autoLabelResult.recommended;
            }
        } else {
            getAutoLabelResponse.errorMessage = await resp.text();
        }
        return Promise.resolve(getAutoLabelResponse);
    }
    return Promise.resolve(null);
}
